import { CSS } from '@grupoboticario/flora-react'

export const panelCss: CSS = {
  alignItems: 'center',
  backgroundColor: '$backgroundSecondary',
  borderRadius: '$medium',
  height: '100%',
  minHeight: '114px',
  padding: '$4',
  width: '100%'
}

export const balanceCss: CSS = {
  flexShrink: 0
}

export const emphasisTextCss: CSS = {
  color: '$linkDefault',
  whiteSpace: 'nowrap'
}

export const dividerCss: CSS = {
  alignSelf: 'stretch',
  backgroundColor: '$nonInteractiveOutline',
  width: '1px'
}
